/*
 * @Author: Teemo Ding
 * @Date: 2021-08-30 14:42:46
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-16 13:16:01
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/Voucher/List/config.tsx
 */
// import { Tag, Image } from 'src/components/Antd';
import GlobalTooltip from '@/src/components/GlobalTooltip/GlobalTooltip';
import StatusTag from '@/src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/StatusTag';
import { Icon } from '@/src/tools/icon';
import React from 'react';
import { DropDown, Menu, MenuItem } from 'src/components/Antd';
import { EDiscountType, EnumStatus } from 'src/types/common/discount';
// import { monent } from 'monent';
import { getI18nFromGeneral } from 'src/tools/tools';
import css from './css.module.less';
import { handleOnFormatCurrentSCTimeAndDate } from 'src/tools/tools';

const typeFilterList = ({ getI18n }) => {
  return {
    [EDiscountType.Percentage]: getI18n('general.percentageOff'),
    [EDiscountType.Reduction]: getI18n('general.fixedReductionAmount'),
    [EDiscountType.Gift]: getI18n('salesChannelSubscriptionBuy.list.freeItems'),
    [EDiscountType.Shipping]: getI18n(
      'salesChannelDirectDiscount.type.shippingDiscount',
    ),
    // [EDiscountType.]: 'Shipping Discount',
  };
};

export enum StatusChange {
  Publish = 'Publish',
  Archive = 'Archive',
  Restore = 'Restore',
  ToDraft = 'ToDraft',
  Duplicate = 'Duplicate',
}

export enum ModalType {
  ArchiveDiscount = 'ArchiveDiscount',
  UnableToPublish = 'UnableToPublish',
}

const overlay = (data) => (
  <Menu className={css.overlay}>
    {data.map((item) => (
      <MenuItem
        disabled={item.disabled}
        className={`${css.menuItem} ${item.name.toLowerCase()}`}
        key={item.key}
        onClick={() => item.function()}>
        {item.name}
      </MenuItem>
    ))}
  </Menu>
);
export enum FrequencyUnit {
  Days = 'Days',
  Weeks = 'Weeks',
  Months = 'Months',
}

export const columns = (
  editFun,
  tabsActive,
  storeTimezoneUTC,
  disableView,
  { getI18n },
) => [
  {
    title: getI18n('salesChannelSubscriptionBuy.list.voucherNo'),
    dataIndex: 'voucherNo',
    key: 'voucherNo',
    default: true,
    // className: css.columnClass,
    sorter: true,
    width: 192,
  },
  ...(tabsActive !== EnumStatus.Archived
    ? [
        {
          title: getI18n('general.status'),
          dataIndex: 'status',
          default: true,
          key: 'status',
          //  className: css.columnClass,
          minWidth: 120,
          ...(tabsActive === tabsConfig[0].key ? { sorter: true } : {}),
          childGenerate: (text, record) => {
            return <StatusTag status={text} />;
          },
        },
      ]
    : []),
  {
    title: getI18n('general.type'),
    dataIndex: 'voucherType',
    default: true,
    key: 'voucherType',
    //  className: css.columnClass,
    minWidth: 200,
    childGenerate: (text, record) => {
      return (
        <GlobalTooltip title={typeFilterList({ getI18n })[text]}>
          {typeFilterList({ getI18n })[text]}
        </GlobalTooltip>
      );
    },
  },
  ...(tabsActive !== EnumStatus.Archived
    ? [
        {
          title: `${getI18n('general.startdate')} (UTC ${storeTimezoneUTC})`,
          default: true,

          dataIndex: 'beginDateTime',
          key: 'beginDateTime',
          minWidth: 212,
          sorter: true,
          childGenerate: (text, record) => {
            return text ? (
              <GlobalTooltip title={handleOnFormatCurrentSCTimeAndDate(text)}>
                {handleOnFormatCurrentSCTimeAndDate(text) || '-'}
              </GlobalTooltip>
            ) : (
              '-'
            );
          },
        },
        {
          title: `${getI18n('general.enddate')} (UTC ${storeTimezoneUTC})`,

          dataIndex: 'endDateTime',
          default: true,
          key: 'endDateTime',
          minWidth: 212,
          sorter: true,
          childGenerate: (text, record) => {
            return text ? (
              <GlobalTooltip title={handleOnFormatCurrentSCTimeAndDate(text)}>
                {handleOnFormatCurrentSCTimeAndDate(text) || '-'}
              </GlobalTooltip>
            ) : (
              '-'
            );
          },
        },
      ]
    : []),
  ...(tabsActive === EnumStatus.Archived
    ? [
        {
          title: `${getI18n('general.lastModified')} (UTC ${storeTimezoneUTC})`,
          default: true,
          dataIndex: 'modifiedDate',
          key: 'modifiedDate',
          className: css.columnClass,
          minWidth: 212,
          sorter: true,
          childGenerate: (text, record) => {
            return text ? (
              <GlobalTooltip title={handleOnFormatCurrentSCTimeAndDate(text)}>
                {handleOnFormatCurrentSCTimeAndDate(text) || '-'}
              </GlobalTooltip>
            ) : (
              ''
            );
          },
        },
        {
          title: `${getI18n(
            'general.status.archived',
          )} (UTC ${storeTimezoneUTC})`,
          dataIndex: 'archivedDate',
          default: true,
          key: 'archivedDate',
          sorter: true,
          minWidth: 212,
          childGenerate: (text, record) => {
            return text ? (
              <GlobalTooltip title={handleOnFormatCurrentSCTimeAndDate(text)}>
                {handleOnFormatCurrentSCTimeAndDate(text) || '-'}
              </GlobalTooltip>
            ) : (
              ''
            );
          },
        },
      ]
    : []),

  {
    title: getI18n(
      'general.advancedFilters.commonStoreProductsWithTable.actions',
    ),
    dataIndex: 'actions',
    default: true,
    key: 'actions',
    className: css.columnClass,
    minWidth: 88,
    align: 'center',
    childGenerate: (text, record) => {
      const overlayActionNoDraftList = overlayActionNoDraft(
        record.uuid,
        editFun,
        disableView,
        { getI18n },
      );
      return (
        <DropDown
          overlay={overlay(overlayActionNoDraftList)}
          placement='bottomRight'
          getPopupContainer={() => document.body}
          trigger={['click']}>
          <div className={css.moreActions}>
            <Icon type='iconMore'></Icon>
          </div>
        </DropDown>
      );
    },
  },
];

const overlayActionNoDraft = (uuid, editFun, disableView, { getI18n }) => [
  {
    name: getI18n('general.edit'),
    key: 1,
    function: () => editFun(uuid, false),
    disabled: disableView,
  },
];

export const breadcrumbData = (
  salesChannelUuid,
  salesChannelName,
  { getI18n },
) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/salesChannels',
    name: getI18n('general.sider.salesChannel'),
  },
  {
    url: `/${salesChannelUuid}`,
    name: salesChannelName,
  },
  {
    url: '',
    name: getI18n('salesChannelDirectDiscount.list.discount'),
  },
  {
    url: '',
    name: getI18n('general.sider.voucher'),
  },
];

export const tabsConfig = [
  //定义tabs列表
  { name: getI18nFromGeneral('general.export1.all'), key: '' },
  { name: getI18nFromGeneral('general.status.draft'), key: EnumStatus.Draft },
  { name: getI18nFromGeneral('general.status.active'), key: EnumStatus.Active },
  { name: getI18nFromGeneral('general.status.issued'), key: EnumStatus.Issued },
  {
    name: getI18nFromGeneral('general.status.expired'),
    key: EnumStatus.Expired,
  },
  {
    name: getI18nFromGeneral('general.status.archive'),
    key: EnumStatus.Archived,
  },
];
